import { formatBoardDate, todayISODate } from "../utils/homepageSeason";

const isoDate = (value) => {
  const match = String(value || "").match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : null;
};

/** Non-deleted squad dates, earliest first. Squad rows or a date list. */
export const squadIsoDates = (tournament) => {
  if (Array.isArray(tournament?.squads) && tournament.squads.length > 0) {
    return tournament.squads
      .filter((squad) => squad && !squad.isDeleted && squad.squadDate)
      .map((squad) => isoDate(squad.squadDate))
      .filter(Boolean)
      .sort();
  }
  if (Array.isArray(tournament?.squadDates)) {
    return tournament.squadDates.map((date) => isoDate(date)).filter(Boolean).sort();
  }
  return [];
};

/** First squad date, or the tournament start when there are no squads. */
export const seasonAnchor = (tournament) => {
  const dates = squadIsoDates(tournament);
  return dates[0] || isoDate(tournament?.startDate || tournament?.start);
};

/** First–last squad dates. Tournament start only when there are no squads. */
export const listDateLabel = (tournament, today = todayISODate()) => {
  const dates = squadIsoDates(tournament);
  const start = dates[0] || isoDate(tournament?.startDate || tournament?.start);
  const end = dates.length ? dates[dates.length - 1] : start;
  if (!start) return "";
  if (!end || end === start) return formatBoardDate(start, today);
  return `${formatBoardDate(start, today)} – ${formatBoardDate(end, today)}`;
};
